import config from "@/../configs";

export default class BaseService {
  defaultHeaders;
  accessToken;
  ApiBaseUrl = config.value("VUE_APP_WEBAPI");
  uriSpecific = "api/v1/";

  constructor(keycloakToken, currentScope = "") {
    this.accessToken = keycloakToken;
    this.defaultHeaders = {
      authorization: `bearer ${keycloakToken}`,
      "X-Current-Scope": currentScope,
      "content-type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Accept: "application/json",
    };
  }

  updateToken(keycloakToken) {
    this.accessToken = keycloakToken;
    this.defaultHeaders.authorization = `bearer ${keycloakToken}`;
  }

  GetUri(apiRoute = null) {
    var uri = this.ApiBaseUrl;
    if (!uri.endsWith("/")) {
      uri = uri + "/";
    }
    return `${uri + this.uriSpecific}${apiRoute !== null ? apiRoute : ''}`;
  }

  GetUriApi() {
    var uri = this.ApiBaseUrl;
    if (!uri.endsWith("/")) {
      uri = uri + "/";
    }

    return uri + this.uriSpecific + "OData/";
  }

  async getAsync(apiRoute, headers = null) {
    const requestOptions = {
      method: "GET",
      headers: headers ?? this.defaultHeaders,
      cache: "default",
    };
    return await fetch(apiRoute, requestOptions)
      .then((response) => response.status == 204 ? null : response.json());
  }

  async get(apiRoute, headers = null) {
    const requestOptions = {
      method: "GET",
      headers: headers ?? this.defaultHeaders,
      cache: "default",
    };
    var result = (await fetch(apiRoute, requestOptions));
    return result.status == 204 ? null : result.json();
  }



  async postAsync(apiRoute, body, headers = null) {
    const requestOptions = {
      method: "POST",
      headers: headers ?? this.defaultHeaders,
      cache: "default",
      body: JSON.stringify(body),
    };
    return await fetch(apiRoute, requestOptions)
      .then((response) => response.status == 204 ? null : response.json());
  }

  async post(apiRoute, body, headers = null) {
    const requestOptions = {
      method: "POST",
      headers: headers ?? this.defaultHeaders,
      cache: "default",
      body: JSON.stringify(body),
    };
    var result = (await fetch(apiRoute, requestOptions));
    return result.status == 204 ? null : result.json();
  }
}
